import React from 'react'
import BookRideSection from '../components/sections/BookRideSection'
import Meta from '../components/common/Meta';
import useMeta from '../hooks/useMeta';

const PrivacyPolicy = () => {
    const meta = useMeta("privacy-policy");
    // console.log("privacy-policy Page Meta:", meta);
    return (
        <>
            {/* Meta tags for SEO */}
            {meta && (
                <Meta
                    title={meta.meta_title}
                    description={meta.meta_description}
                    keywords={meta.meta_keywords}
                />
            )}
            <section className="terms_conditions section_pt section_pb">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="privacy_section">
                                <h2 className="title">Privacy Policy</h2>
                                <p><small>Welcome to Orbicabs. Your privacy is important to us. This policy explains how we
                                    collect, use, store, and protect your personal information when you use our website,
                                    mobile apps, or services.</small> </p>
                                <br />
                                <h4>1. Information We Collect</h4>
                                <p>We may collect the following types of personal information:</p>

                                <h6>a. From Customers:</h6>
                                <ul>
                                    <li>Name, email address, phone number</li>
                                    <li>Pickup and drop locations</li>
                                    <li>Device and location data (with permission)</li>
                                    <li>Payment and billing details (processed via secure third-party gateways)</li>
                                    <li>Feedback, ride history, and app usage data</li>
                                </ul>

                                <h6>b. From Transporters & Drivers:</h6>
                                <ul>
                                    <li>Name, business details, contact info</li>
                                    <li>Driver licenses, vehicle details, and photos</li>
                                    <li>Bank account information for payouts</li>
                                    <li>Ride and performance logs</li>
                                </ul>
                                <h4>2. How We Use Your Information</h4>
                                <p>We use your data to:</p>
                                <ul>
                                    <li>Facilitate and manage ride bookings</li>
                                    <li>Assign drivers and vehicles</li>
                                    <li>FEnable real-time ride tracking</li>
                                    <li>Process payments and issue invoices/refunds</li>
                                    <li>Communicate important ride updates or promotions</li>
                                    <li>Improve app functionality, performance, and support</li>
                                    <li>Comply with legal or regulatory obligations</li>
                                </ul>

                                <h4>3. Data Sharing & Disclosure</h4>
                                <p>
                                    We do not sell or rent your personal data. We may share information with:
                                </p>
                                <ul>
                                    <li>Assigned transporters/drivers for ride fulfillment</li>
                                    <li>Payment processors (e.g.,Cashfree, Razorpay, Stripe, etc.)</li>
                                    <li>Government agencies, if required by law</li>
                                    <li>Internal team members for support or auditing</li>
                                    <li>Third-party tools (e.g., SMS/email services) under strict confidentiality agreements
                                    </li>
                                </ul>
                                <h4>4. Data Security</h4>
                                <p>We implement strict security measures to protect your personal information, including:</p>
                                <ul>
                                    <li>SSL encryption</li>
                                    <li>Secure cloud storage</li>
                                    <li>Restricted internal access to sensitive data</li>
                                    <li>Regular monitoring of security systems</li>
                                </ul>
                                <p>However, no digital transmission is 100% secure, and we cannot guarantee absolute protection.
                                </p>
                                <h4>5. User Control & Consent</h4>
                                <p>
                                    You can:
                                </p>
                                <ul>
                                    <li>Access or update your profile via the app</li>
                                    <li>Request deletion of your account/data</li>

                                    <li>Opt out of marketing emails and SMS</li>
                                    <li>Manage app permissions (e.g., location)</li>

                                </ul>
                                <p>To exercise any of the above, email us at: [support@orbicabs.com]</p>
                                <h4>6. Cookies & Tracking (Website only)</h4>
                                <p>We may use cookies to:
                                </p>
                                <ul>
                                    <li>Track website performance</li>
                                    <li>Remember user preferences</li>
                                    <li>Serve relevant content or promotions</li>
                                </ul>
                                <p>You can manage cookies in your browser settings.</p>
                                <h4>7. Children’s Privacy</h4>
                                <p>Our services are not intended for users under the age of 18. We do not knowingly collect data
                                    from minors. If you believe we have inadvertently collected data from a child, please
                                    contact us immediately.</p>
                                <h4>8. Policy Updates</h4>
                                <p>This Privacy Policy may be updated from time to time. We’ll notify users of significant
                                    changes via email or in-app messages. The revised policy will take effect immediately upon
                                    publication.
                                </p>
                                <h4>9. Contact Us</h4>
                                <p>If you have any questions or concerns regarding your privacy or this policy, please reach out:
                                </p>
                                <p>
                                    📞 +91 75 3505 1511<br />
                                    📞 +91 90 4136 4870<br />
                                    📧 support@orbicabs.com<br />
                                    🤝 partner@orbicabs.com<br />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* book ride section */}
            <BookRideSection />
        </>
    )
}

export default PrivacyPolicy